import type {
  ActiveDocumentRef,
  ContentFormat,
  HostAdapter,
  Scope,
  SelectionInfo,
} from './host-adapter'

/**
 * Fallback used when the taskpane runs in a plain browser (no Office.js),
 * so the UI is fully developable without sideloading into Word.
 */
export class BrowserAdapter implements HostAdapter {
  readonly host = 'browser' as const
  readonly canEdit = true

  private selection =
    'Sehr geehrte Damen und Herren, anbei senden wir Ihnen die angeforderten Unterlagen.'
  private documentText =
    'Angebot 2026\n\nSehr geehrte Damen und Herren, anbei senden wir Ihnen die angeforderten Unterlagen. ' +
    'Bitte prüfen Sie die beigefügten Positionen.'

  async getSelection(): Promise<SelectionInfo> {
    return { text: this.selection, paragraphs: 1, isEmpty: false }
  }

  async getDocumentText(): Promise<string> {
    return this.documentText
  }

  async getContent(scope: Scope): Promise<string> {
    if (scope === 'none') return ''
    return scope === 'selection' ? this.selection : this.documentText
  }

  async replaceSelection(content: string, _format?: ContentFormat): Promise<void> {
    this.selection = content
    console.info('[BrowserAdapter] replaceSelection:', content)
  }

  async insertAtCursor(content: string, _format?: ContentFormat): Promise<void> {
    console.info('[BrowserAdapter] insertAtCursor:', content)
  }

  async getActiveDocument(): Promise<ActiveDocumentRef | null> {
    return { name: 'Doc1.docx' }
  }
}
